module.exports = __webpack_public_path__ + "static/media/dibari2.c9992800.jpg";